import React from "react"
import styled from "styled-components"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import { color } from "../../configs/utilities"
import {
  SectionTitle,
  SectionText,
} from "../../components/common/typography/Typography"
import template from "../../assets/mover/template.png"
import ButtonLink from "../../components/common/buttons/ButtonLink"

const AboutMoverSection = ({ logo, name, description }) => {
  return (
    <Wrapper>
      <SectionWrapper paddingSm="30px 20px" paddingXl="40px 100px">
        <LogoWrapper>
          <Logo>
            <img
              src={logo ? logo : template}
              alt={`${name} Logo`}
              width="160"
              height="auto"
            />
          </Logo>
          <ButtonLink
            to="/contact-update-mover"
            buttonText="Claim listing"
            buttonBackground={color.sand}
            buttonTextColor={color.gray}
          />
        </LogoWrapper>
        <SectionTitle>About</SectionTitle>
        <SectionText>{description}</SectionText>
      </SectionWrapper>
    </Wrapper>
  )
}

export default AboutMoverSection

const Wrapper = styled.div``

const LogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const Logo = styled.div`
  width: 100%;
  max-width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: ${color.logoBackground};
  border-radius: 8px;
  margin-bottom: 50px;
  padding: 20px;

  img {
    width: 100%;
    max-width: 160px;
    border-radius: 4px;
  }
`
